module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "news-title on-show-two"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "news-read-time"
  }, [_c('span', [_vm._v("阅读" + _vm._s(_vm.row.views_count))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.row.create_time_ago))])]), _vm._v(" "), (_vm.row.files.length > 0) ? _c('div', {
    staticClass: "fdown"
  }, [_vm._v("\n      文件下载\n      \n      "), _vm._l((_vm.row.files), function(file, key) {
    return _c('p', {
      key: key,
      on: {
        "click": function($event) {
          return _vm.download(file)
        }
      }
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "t": "1646357503345",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "2092",
        "width": "16",
        "height": "16"
      }
    }, [_c('path', {
      attrs: {
        "d": "M828.975746 894.125047 190.189132 894.125047c-70.550823 0-127.753639-57.18542-127.753639-127.752616L62.435493 606.674243c0-17.634636 14.308891-31.933293 31.93227-31.933293l63.889099 0c17.634636 0 31.93227 14.298658 31.93227 31.933293l0 95.821369c0 35.282574 28.596292 63.877843 63.87682 63.877843L765.098927 766.373455c35.281551 0 63.87682-28.595268 63.87682-63.877843l0-95.821369c0-17.634636 14.298658-31.933293 31.943526-31.933293l63.877843 0c17.634636 0 31.933293 14.298658 31.933293 31.933293l0 159.699212C956.729385 836.939627 899.538849 894.125047 828.975746 894.125047L828.975746 894.125047zM249.938957 267.509636c12.921287-12.919241 33.884738-12.919241 46.807049 0l148.97087 148.971893L445.716876 94.89323c0-17.634636 14.300704-31.94762 31.933293-31.94762l63.875796 0c17.637706 0 31.945573 14.312984 31.945573 31.94762l0 321.588299 148.97087-148.971893c12.921287-12.919241 33.875528-12.919241 46.796816 0l46.814212 46.818305c12.921287 12.922311 12.921287 33.874505 0 46.807049L552.261471 624.930025c-1.140986 1.137916-21.664416 13.68365-42.315758 13.69286-20.87647 0.010233-41.878806-12.541641-43.020816-13.69286L203.121676 361.13499c-12.922311-12.933567-12.922311-33.884738 0-46.807049L249.938957 267.509636 249.938957 267.509636z",
        "p-id": "2093",
        "fill": "#1296db"
      }
    })]), _vm._v(" " + _vm._s(file.name))])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "news-content",
    domProps: {
      "innerHTML": _vm._s(_vm.row.content)
    }
  }), _vm._v(" "), (_vm.row.id == 960) ? _c('div', _vm._l((_vm.shequList), function(sqvalue, sqindex) {
    return _c('div', {
      key: sqindex
    }, [_c('van-divider', [_vm._v(_vm._s(sqindex))]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
      attrs: {
        "title": sqindex,
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.sqdonwload(sqindex, '')
        }
      }
    }), _vm._v(" "), _vm._l((sqvalue), function(sqcvalue, sqcindex) {
      return _c('van-cell', {
        key: sqcindex,
        attrs: {
          "title": sqcvalue,
          "is-link": ""
        },
        on: {
          "click": function($event) {
            return _vm.sqdonwload(sqindex, sqcvalue)
          }
        }
      })
    })], 2)], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.row.vote_url) ? _c('iframe', {
    staticStyle: {
      "border": "none",
      "outline": "none"
    },
    attrs: {
      "width": "100%",
      "height": "2000px",
      "src": _vm.row.vote_url
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zan-box"
  }, [_c('span', {
    staticClass: "zan-num"
  }, [_vm._v(_vm._s(_vm.row.zan_list.length) + "赞")]), _vm._v(" "), _vm._l((_vm.row.zan_list), function(item, i) {
    return _c('img', {
      key: i,
      staticClass: "user-zan-face",
      attrs: {
        "src": item.user_face,
        "alt": ""
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "comments-box"
  }, [_c('div', {
    staticClass: "comments-box-title"
  }, [_vm._v("评论")]), _vm._v(" "), (_vm.row.comment_list.length > 0) ? _c('div', {
    staticClass: "comments-list-box"
  }, _vm._l((_vm.row.comment_list), function(item, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.is_show == 1 || item.is_admin),
        expression: "item.is_show==1||item.is_admin"
      }],
      key: i,
      staticClass: "comments-list",
      on: {
        "click": function($event) {
          return _vm.onToUserComment(item)
        },
        "touchstart": function($event) {
          return _vm.showCommentDeleteButton(item, i)
        },
        "touchend": _vm.emptyTime
      }
    }, [_c('div', [_c('div', {
      staticClass: "user-face"
    }, [_c('img', {
      attrs: {
        "src": item.user_face
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "user-info"
    }, [_c('div', {
      staticClass: "user-names"
    }, [_vm._v(_vm._s(item.user_name))]), _vm._v(" "), _c('div', {
      staticClass: "look-info"
    }, [_vm._v(_vm._s(item.create_time_ago))])])]), _vm._v(" "), (item.to_user_name == null) ? _c('div', {
      staticClass: "comments-content"
    }, [_vm._v(_vm._s(item.content))]) : _c('div', {
      staticClass: "comments-content"
    }, [_c('span', {
      staticStyle: {
        "color": "#ccc"
      }
    }, [_vm._v("\n              回复\n              "), _c('span', {
      staticStyle: {
        "color": "#000"
      }
    }, [_vm._v(_vm._s(item.to_user_name) + ":")])]), _vm._v("\n            " + _vm._s(item.content) + "\n          ")])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.ltActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "select": _vm.onLtSelect,
      "cancel": function($event) {
        _vm.ltShow = false
      }
    },
    model: {
      value: (_vm.ltShow),
      callback: function($$v) {
        _vm.ltShow = $$v
      },
      expression: "ltShow"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "share-box share-right"
  }, [_c('div', {
    staticClass: "share-right-texts",
    on: {
      "click": function($event) {
        _vm.show_share_panel = true
      }
    }
  }, [_vm._v("分享给好友")])]), _vm._v(" "), (_vm.showWxShare) ? _c('div', {
    staticClass: "shareShow",
    on: {
      "click": _vm.onShareCancel
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '30%'
    }),
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.show_share_panel),
      callback: function($$v) {
        _vm.show_share_panel = $$v
      },
      expression: "show_share_panel"
    }
  }, [_c('div', {
    staticClass: "share-panel"
  }, [_c('div', {
    staticClass: "share-title"
  }, [_vm._v("请选择分享方式")]), _vm._v(" "), _c('div', {
    staticClass: "share-ul"
  }, [_c('div', {
    staticClass: "share-weixin",
    on: {
      "click": _vm.shareWeixinFriend
    }
  }, [_c('p', [_vm._v("微信好友")])]), _vm._v(" "), _c('div', {
    staticClass: "share-timeline",
    on: {
      "click": _vm.shareWeixinTimeLine
    }
  }, [_c('p', [_vm._v("朋友圈")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.copy_text),
      expression: "copy_text",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (function() {
        _vm.copySuccess();
        _vm.show_share_panel = false
      }),
      expression: "function(){copySuccess();show_share_panel=false }",
      arg: "success"
    }],
    staticClass: "share-copy"
  }, [_c('p', [_vm._v("复制链接")])])])])]), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.sheetCommentActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.sheetCommentShow),
      callback: function($$v) {
        _vm.sheetCommentShow = $$v
      },
      expression: "sheetCommentShow"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "send-comments"
  }, [_c('van-field', {
    attrs: {
      "maxlength": "50",
      "placeholder": _vm.commentsPlaceholder,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zan-btn"
  }, [(!_vm.row.is_zan) ? _c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/icon-active-de0.png"),
      "alt": ""
    },
    on: {
      "click": _vm.onAddZan
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../assets/images/activity/icon-active-de1.png"),
      "alt": ""
    },
    on: {
      "click": _vm.onRemoveZan
    }
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点击分享给好友")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-603d4520","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/news/NewsDetail.vue
// module id = 2431
// module chunks = 0